var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertsDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.307,
    height: 18,
    viewBox: "0 0 18.307 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160692",
    "data-name": "Group 160692",
    transform: "translate(-503.693 -296)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 18,
    height: 18,
    transform: "translate(504 296)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M12.273,4.665,11.266,2.987a1.579,1.579,0,0,0-2.173-.535,1.632,1.632,0,0,0-.535.535L1.846,14.2a1.584,1.584,0,0,0,.583,2.165,1.662,1.662,0,0,0,.775.216H16.627a1.583,1.583,0,0,0,1.35-2.381l-3.859-6.44",
    transform: "translate(502.92 294.755)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160613",
    "data-name": "Group 160613",
    transform: "translate(508.362 301.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M11.353,8.813l-3.59,5.993a.846.846,0,0,0,.309,1.155.827.827,0,0,0,.413.113h7.18a.843.843,0,0,0,.836-.856.827.827,0,0,0-.113-.413L12.8,8.813a.849.849,0,0,0-1.455,0Z",
    transform: "translate(-7.649 -8.404)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M0,0V1.738",
    transform: "translate(4.427 2.562)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x2: 0.011,
    transform: "translate(4.427 6.038)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 0.455,
    cy: 0.455,
    r: 0.455,
    transform: "translate(515.761 300.546)",
    fill: "#165cf3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsDarkIcon);
export default __webpack_public_path__ + "static/media/alerts-dark-icon.2f5968ec33edee2cbeec8355b4e8b094.svg";
export { ForwardRef as ReactComponent };